"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processTasks = exports.tasks = void 0;
exports.tasks = [
    {
        task_id: "StartDecoratorRulesSubprocess",
        task_type: "startEvent",
        task_name: "Start decoration",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CopyCaseDataToProcessInstanceServiceTask",
        task_type: "serviceTask",
        task_name: "Copy case data to process Instance",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateCaseStatusToInProcessServiceTask",
        task_type: "serviceTask",
        task_name: "Update case status to 'In Process'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartPrePredictionRulesSubprocess",
        task_type: "startEvent",
        task_name: "Start pre-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RetrieveCaseNotesServiceTask",
        task_type: "serviceTask",
        task_name: "Retrieve notes",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "PostPredictionSaveCaseServiceTask",
        task_type: "serviceTask",
        task_name: "Save case",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartPredictionSubprocess",
        task_type: "startEvent",
        task_name: "Start prediction",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "SaveCaseServiceTask",
        task_type: "serviceTask",
        task_name: "Save case",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndRoutingSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End routing",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndDecoratorRulesSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End decoration",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "ExitRoutingInclusiveGateway",
        task_type: "inclusiveGateway",
        task_name: "blah",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RouteToCACSubprocess",
        task_type: "callActivity",
        task_name: "Route to CAC",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "IsAllRequiredCaseDataAvailableExclusiveGateway",
        task_type: "exclusiveGateway",
        task_name: "Is all required case data available?",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartSendToCACSubprocess",
        task_type: "startEvent",
        task_name: "Start send to CAC",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunPostPredictionRulesSubprocess",
        task_type: "callActivity",
        task_name: "Run post-prediction rules",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartRoutingSubprocess",
        task_type: "startEvent",
        task_name: "Start routing",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RetrieveAndSaveExamCodeMapServiceTask",
        task_type: "serviceTask",
        task_name: "Retrieve and save exam code map",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RecordReasonServiceTask",
        task_type: "serviceTask",
        task_name: "Record reason",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateCaseStatusToDone",
        task_type: "serviceTask",
        task_name: "Update case status to 'Done'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateProcessInstanceToDataCollectedServiceTask",
        task_type: "serviceTask",
        task_name: "Update process instance to 'data collected'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "IsAllRequiredProcessInstanceDataAvailableExclusiveGateway",
        task_type: "exclusiveGateway",
        task_name: "Is all requried process instance data available?",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CheckProcessInstanceRequiredFieldsServiceTask",
        task_type: "serviceTask",
        task_name: "Check process instance required fields",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StorePredictedArtifactsServiceTask",
        task_type: "serviceTask",
        task_name: "Store predicted artifacts",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CheckRouteToBillingExclusiveGateway",
        task_type: "exclusiveGateway",
        task_name: "Selected destination?",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndPredictionSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End prediction",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunTenantPostPredictionRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run tenant post-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateProcessInstanceStatustoPredictedServiceTask",
        task_type: "serviceTask",
        task_name: "Update process instance status to 'Predicted'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateProcessInstanceStatusToStartedServiceTask",
        task_type: "serviceTask",
        task_name: "Update process Instance status to 'Started'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunTenantPrePredictionRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run tenant pre-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunPrePredictionRulesSubprocess",
        task_type: "callActivity",
        task_name: "Run pre-prediction rules",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "UpdateCaseStatusToCaseDataCollectedServiceTask",
        task_type: "serviceTask",
        task_name: "Update case status to 'Case data collected'",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartPostPredictionRuleSubprocess",
        task_type: "startEvent",
        task_name: "Start post-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "WaitForCaseDataTimerCatchEvent",
        task_type: "intermediateTimer",
        task_name: "Wait for case data",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CheckRouteToPredictExclusiveGateway",
        task_type: "exclusiveGateway",
        task_name: "Route to predict?",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndSendToCACSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End send to CAC",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CheckCaseRequiredFieldsServiceTask",
        task_type: "serviceTask",
        task_name: "Check case required fields",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunDecorateRulesSubprocess",
        task_type: "callActivity",
        task_name: "Run decoration rules",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "MockPyramidServiceTask",
        task_type: "serviceTask",
        task_name: "Mock prediction\n(no Pyramid)",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CollectCaseHL7ServiceTask",
        task_type: "serviceTask",
        task_name: "Collect case HL7",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunSystemPrePredictionRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run system pre-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunTenantDecorationRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run tenant Decoration rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndPrePredictionRulesSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End pre-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "PredictionSubprocess",
        task_type: "callActivity",
        task_name: "Run prediction subprocess",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "EndPostPredictionRuleSubprocess",
        task_type: "terminateEndEvent",
        task_name: "End post-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "GetPredictionConfigurationServiceTask",
        task_type: "serviceTask",
        task_name: "Get prediction configuration",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StoreArtifactsServiceTask",
        task_type: "serviceTask",
        task_name: "Store artifacts",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "SendHL7ToCACServiceTask",
        task_type: "serviceTask",
        task_name: "Send HL7 to CAC",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "PostPredictionRoutingSubprocess",
        task_type: "callActivity",
        task_name: "Run routing subprocess",
        incoming_transitions: "",
        task_iterations: 1,
        task_end_timestamp: "",
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunSystemPostPredictionRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run system post-prediction rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "PostPredictionEndEvent",
        task_type: "terminateEndEvent",
        task_name: "Post-prediction process end",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RetrieveProcessInstanceServiceTask",
        task_type: "serviceTask",
        task_name: "Retrieve process instance",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RetrieveCaseConfigurationServiceTask",
        task_type: "serviceTask",
        task_name: "Retrieve case configuration",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "StartLiveRadiologyProcess",
        task_type: "conditionalStartEvent",
        task_name: "Start radiology process",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RunSystemDecorationRulesServiceTask",
        task_type: "businessRuleTask",
        task_name: "Run system decoration rules",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "RetrieveSourceSystemArtifactServiceTask",
        task_type: "serviceTask",
        task_name: "Retrieve source system artifacts",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "CollectCaseDataServiceTask",
        task_type: "serviceTask",
        task_name: "Collect case data",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    },
    {
        task_id: "SelectedRoutesInclusiveGateway",
        task_type: "inclusiveGateway",
        task_name: "Selected routes?",
        incoming_transitions: "",
        task_end_timestamp: "",
        task_iterations: 1,
        task_inputs: {},
        task_outputs: {},
        outgoing_transitions: ""
    }
];
exports.processTasks = {
    tasks: exports.tasks
};
//# sourceMappingURL=tasks-2.js.map